import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Reveal } from '../hooks/useReveal';
import { SectionTitle } from './About';
import { assets } from '../mock';

const VideoSection = () => {
  const { t } = useLanguage();
  return (
    <section id="video" className="section-pad bg-gradient-to-b from-[#14120d] via-[#1e1a11] to-[#14120d]">
      <div className="max-w-5xl mx-auto">
        <Reveal>
          <SectionTitle eyebrow={t.video.eyebrow} title={t.video.title} subtitle={t.video.subtitle} />
        </Reveal>
        <Reveal delay={120}>
          <div className="relative mt-12">
            <div className="absolute -top-3 -left-3 w-20 h-20 border-t border-l border-[#e6b83f]/50" />
            <div className="absolute -bottom-3 -right-3 w-20 h-20 border-b border-r border-[#e6b83f]/50" />
            <div className="relative aspect-video w-full overflow-hidden shadow-2xl bg-black border border-[#e6b83f]/20">
              <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${assets.youtubeId}`}
                title="LAJO PROMO 2026"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default VideoSection;
